<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>

<div class="mi-cuenta-page">
   <!-- begin::Header -->
   <div class="mc-header mc-card">
      <div class="mc-header-text">
         <div class="mc-breadcrumb">
            <a routerLink="/inicio">Inicio</a>
            <span class="separator">/</span>
            <span class="current">Mi Cuenta</span>
         </div>
         <h1 class="mc-title">Mi Cuenta</h1>
         <p class="mc-subtitle">Gestiona tu información personal, seguridad, accesos<ng-container *ngIf="puedeVerBilletera">, billetera</ng-container> y empresas asociadas.</p>
      </div>
   </div>
   <!-- end::Header -->

   <!-- begin::Tabs -->
   <div class="mc-tabs">
      <button class="mc-tab" [class.active]="activeTab === 'resumen'" (click)="setTab('resumen')">
         <i class="fas fa-th-large"></i>
         <span>Resumen</span>
      </button>
      <button class="mc-tab" [class.active]="activeTab === 'datos'" (click)="setTab('datos')">
         <i class="fas fa-user"></i>
         <span>Datos personales</span>
      </button>
      <button class="mc-tab" [class.active]="activeTab === 'seguridad'" (click)="setTab('seguridad')">
         <i class="fas fa-shield-alt"></i>
         <span>Seguridad</span>
      </button>
      <button class="mc-tab" [class.active]="activeTab === 'metodos'" (click)="setTab('metodos')">
         <i class="fas fa-link"></i>
         <span>Métodos de acceso</span>
      </button>
      <button class="mc-tab" [class.active]="activeTab === 'empresas'" (click)="setTab('empresas')">
         <i class="fas fa-building"></i>
         <span>Empresas y sucursales</span>
      </button>
      <button *ngIf="esUsuarioBase" class="mc-tab" [class.active]="activeTab === 'cambio-usuario-base'" (click)="setTab('cambio-usuario-base')">
         <i class="fas fa-people-arrows"></i>
         <span>Transferir usuario base</span>
      </button>
      <button *ngIf="puedeVerBilletera" class="mc-tab" [class.active]="activeTab === 'billetera'" (click)="setTab('billetera')">
         <i class="fas fa-wallet"></i>
         <span>Mi billetera</span>
      </button>
   </div>
   <!-- end::Tabs -->

   <!-- begin::Body -->
   <div class="mc-body">
      <!-- ============== RESUMEN ============== -->
      <ng-container *ngIf="activeTab === 'resumen'">
         <div class="mc-row">
            <!-- Tarjeta usuario -->
            <div class="mc-card mc-user-card">
               <div class="mc-avatar mc-avatar-lg">
                  <img *ngIf="avatarSrc; else resumenInitials" [src]="avatarSrc" alt="" class="mc-avatar-img" referrerpolicy="no-referrer" crossorigin="anonymous" (error)="onAvatarImageError(avatarSrc)" />
                  <ng-template #resumenInitials><span class="mc-avatar-initials">{{ initials }}</span></ng-template>
                  <span class="mc-avatar-badge"><i class="fas fa-user"></i></span>
               </div>
               <div class="mc-user-name">{{ currentUser.nombre }} {{ currentUser.apellidos }}</div>
               <div class="mc-user-cargo">{{ currentUser.cargo || "Sin cargo" }}</div>
               <div class="mc-badge-rol">{{ getRolPrincipal() }}</div>

               <div class="mc-user-info">
                  <div class="info-row"><i class="fas fa-envelope"></i><a href="mailto:{{ currentUser.email }}">{{ currentUser.email }}</a></div>
                  <div class="info-row"><i class="fas fa-phone"></i><span>{{ currentUser.telefono }}</span></div>
                  <div class="info-row"><i class="fas fa-id-badge"></i><span>{{ currentUser.cargo || "Sin cargo asignado" }}</span></div>
                  <div class="info-row"><i class="fas fa-clock"></i><span>Últ. acceso: {{ currentUser.ultimoAcceso | date : "dd/MM/yyyy HH:mm" }} hrs.</span></div>
               </div>
            </div>

            <!-- Accesos rápidos y otros -->
            <div class="mc-col-right">
               <div class="mc-card">
                  <div class="mc-section-title">ESTADO DE SEGURIDAD</div>
                  <div class="security-banner" [class.ok]="emailVerificado" [class.warn]="!emailVerificado">
                     <i class="fas" [ngClass]="emailVerificado ? 'fa-shield-alt' : 'fa-exclamation-triangle'"></i>
                     <div class="security-text">
                        <div class="security-title">{{ emailVerificado ? "Cuenta protegida" : "Correo pendiente de verificación" }}</div>
                        <div class="security-detail">{{ passwordStatusTitle }} · {{ emailVerificado ? "Correo verificado" : "Correo no verificado" }}</div>
                     </div>
                     <a class="mc-link" (click)="setTab('seguridad')">Gestionar</a>
                  </div>
               </div>

               <div class="mc-card">
                  <div class="mc-section-title">ACCESOS RÁPIDOS</div>
                  <div class="quick-grid">
                     <button class="quick-item" (click)="setTab('datos')">
                        <i class="fas fa-user-edit"></i>
                        <span>Modificar datos personales</span>
                        <i class="fas fa-chevron-right ml-auto"></i>
                     </button>
                     <button class="quick-item" (click)="setTab('seguridad')">
                        <i class="fas fa-lock"></i>
                        <span>{{ passwordActionLabel }}</span>
                        <i class="fas fa-chevron-right ml-auto"></i>
                     </button>
                     <button class="quick-item" (click)="setTab('metodos')">
                        <i class="fas fa-link"></i>
                        <span>Gestionar métodos de acceso</span>
                        <i class="fas fa-chevron-right ml-auto"></i>
                     </button>
                     <button class="quick-item" (click)="setTab('empresas')">
                        <i class="fas fa-building"></i>
                        <span>Ver empresas y sucursales</span>
                        <i class="fas fa-chevron-right ml-auto"></i>
                     </button>
                     <button *ngIf="puedeVerBilletera" class="quick-item" (click)="setTab('billetera')">
                        <i class="fas fa-wallet"></i>
                        <span>Consultar mi billetera</span>
                        <i class="fas fa-chevron-right ml-auto"></i>
                     </button>
                  </div>
               </div>

               <div class="mc-card">
                  <div class="mc-section-title-row">
                     <span class="mc-section-title">EMPRESAS ASOCIADAS</span>
                     <a class="mc-link" (click)="setTab('empresas')">Ver detalle</a>
                  </div>
                  <div class="company-list">
                     <div class="company-item" *ngFor="let item of empresasResumen">
                        <div class="company-icon"><i class="fas fa-building"></i></div>
                        <div class="company-info">
                           <div class="company-name">{{ item.emisor.razonSocial }}</div>
                           <div class="company-meta">
                              RUT {{ item.emisor.rutString || (item.emisor.rut + '-' + item.emisor.dv) }}
                              <span *ngIf="item.sucursales && item.sucursales.length > 0"> · {{ item.sucursales[0].direccion }}</span>
                           </div>
                        </div>
                     </div>
                     <div *ngIf="empresasResumenRestantes > 0" class="company-more" (click)="setTab('empresas')">
                        <i class="fas fa-ellipsis-h"></i>
                        <span>+ {{ empresasResumenRestantes }} empresa(s) más</span>
                        <a class="mc-link ml-auto">Ver detalle</a>
                     </div>
                     <div *ngIf="empresasPermisos.length === 0" class="empty-row">Sin empresas asociadas</div>
                  </div>
               </div>
            </div>
         </div>
      </ng-container>

      <!-- ============== DATOS PERSONALES ============== -->
      <ng-container *ngIf="activeTab === 'datos'">
         <div class="mc-row datos-row">
            <div class="mc-card mc-photo-card">
               <div class="mc-card-title">Foto de perfil</div>
               <div class="mc-avatar mc-avatar-xl">
                  <img *ngIf="avatarSrc; else datosInitials" [src]="avatarSrc" alt="" class="mc-avatar-img" referrerpolicy="no-referrer" crossorigin="anonymous" (error)="onAvatarImageError(avatarSrc)" />
                  <ng-template #datosInitials><span class="mc-avatar-initials">{{ initials }}</span></ng-template>
               </div>
               <p class="photo-hint">La foto puede ser cargada manualmente o seleccionada desde una cuenta vinculada.</p>
               <input type="file" #avatarInput accept="image/*" hidden (change)="onAvatarFileSelected($event)" />
               <button class="btn-action btn-outline-primary" (click)="avatarInput.click()">
                  <i class="fas fa-upload"></i> Subir foto
               </button>
               <button *ngIf="cuentaResumen?.avatarSeleccionado" class="btn-action btn-outline-danger" (click)="deleteAvatar(cuentaResumen.avatarSeleccionado)">
                  <i class="fas fa-trash"></i> Eliminar foto
               </button>
               <div class="avatar-options" *ngIf="cuentaResumen?.avatars?.length">
                  <button type="button" class="avatar-option" *ngFor="let avatar of cuentaResumen.avatars" [class.active]="avatar.seleccionado" (click)="selectAvatar(avatar)">
                     <img *ngIf="avatarSource(avatar)" [src]="avatarSource(avatar)" alt="" referrerpolicy="no-referrer" crossorigin="anonymous" (error)="onAvatarImageError(avatarSource(avatar))" />
                     <span *ngIf="!avatarSource(avatar)">{{ initials }}</span>
                  </button>
               </div>
            </div>

            <form class="mc-card datos-card" [formGroup]="usuarioForm" (ngSubmit)="onSubmit()" #usuarioFormRef="ngForm">
               <div class="datos-header">
                  <div class="mc-card-title">Datos personales</div>
                  <div class="datos-header-actions" *ngIf="!datosEditMode; else editActions">
                     <button type="button" class="btn-primary-sm" (click)="enableEditDatos()">
                        <i class="fas fa-pencil-alt"></i> Modificar datos
                     </button>
                  </div>
                  <ng-template #editActions>
                     <div class="datos-header-actions">
                        <button type="button" class="btn-outline-secondary-sm" (click)="cancelEditDatos()">
                           <i class="fas fa-times"></i> Cancelar
                        </button>
                        <button type="submit" class="btn-primary-sm">
                           <i class="fas fa-check"></i> Guardar cambios
                        </button>
                     </div>
                  </ng-template>
               </div>

               <div class="datos-grid">
                  <div class="datos-item">
                     <div class="datos-label">Nombres</div>
                     <ng-container *ngIf="datosEditMode; else viewNombre">
                        <input type="text" formControlName="nombre" class="datos-input" />
                        <div *ngIf="usuarioFormRef.submitted && usuarioForm.get('nombre').invalid" class="datos-error">Campo requerido</div>
                     </ng-container>
                     <ng-template #viewNombre>
                        <div class="datos-value">{{ currentUser.nombre }}</div>
                     </ng-template>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">Apellidos</div>
                     <ng-container *ngIf="datosEditMode; else viewApellidos">
                        <input type="text" formControlName="apellidos" class="datos-input" />
                        <div *ngIf="usuarioFormRef.submitted && usuarioForm.get('apellidos').invalid" class="datos-error">Campo requerido</div>
                     </ng-container>
                     <ng-template #viewApellidos>
                        <div class="datos-value">{{ currentUser.apellidos }}</div>
                     </ng-template>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">RUT</div>
                     <div class="datos-value">{{ currentUser.rutFormateado || (currentUser.rut + '-' + currentUser.dv) }}</div>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">Correo electrónico</div>
                     <div class="datos-value">{{ currentUser.email }}</div>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">Cargo</div>
                     <ng-container *ngIf="datosEditMode; else viewCargo">
                        <input type="text" formControlName="cargo" class="datos-input" placeholder="Cargo en la empresa" />
                     </ng-container>
                     <ng-template #viewCargo>
                        <div class="datos-value" [class.text-muted]="!currentUser.cargo">{{ currentUser.cargo || "No especificado" }}</div>
                     </ng-template>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">Perfil / Rol</div>
                     <div class="datos-value">{{ getRolPrincipal() }}</div>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">Teléfono</div>
                     <ng-container *ngIf="datosEditMode; else viewTelefono">
                        <input type="number" formControlName="telefono" class="datos-input" maxlength="9" minlength="9" />
                        <div *ngIf="usuarioFormRef.submitted && usuarioForm.get('telefono').invalid" class="datos-error">Teléfono inválido (9 dígitos)</div>
                     </ng-container>
                     <ng-template #viewTelefono>
                        <div class="datos-value">{{ currentUser.telefono }}</div>
                     </ng-template>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">Dirección</div>
                     <ng-container *ngIf="datosEditMode; else viewDireccion">
                        <input type="text" formControlName="direccion" class="datos-input" />
                        <div *ngIf="usuarioFormRef.submitted && usuarioForm.get('direccion').invalid" class="datos-error">Campo requerido</div>
                     </ng-container>
                     <ng-template #viewDireccion>
                        <div class="datos-value">{{ currentUser.direccion }}</div>
                     </ng-template>
                  </div>

                  <div class="datos-item">
                     <div class="datos-label">Comuna</div>
                     <ng-container *ngIf="datosEditMode; else viewComuna">
                        <input type="text" formControlName="comuna" class="datos-input" />
                        <div *ngIf="usuarioFormRef.submitted && usuarioForm.get('comuna').invalid" class="datos-error">Campo requerido</div>
                     </ng-container>
                     <ng-template #viewComuna>
                        <div class="datos-value">{{ currentUser.comuna }}</div>
                     </ng-template>
                  </div>
               </div>
            </form>
         </div>
      </ng-container>

      <!-- ============== SEGURIDAD ============== -->
      <ng-container *ngIf="activeTab === 'seguridad'">
         <div class="mc-stack">
            <div class="mc-card">
               <div class="mc-card-title">Actividad reciente</div>
               <div class="security-row">
                  <i class="far fa-clock"></i>
                  <div class="sr-info">
                     <div class="sr-title">Último acceso</div>
                     <div class="sr-detail">{{ currentUser.ultimoAcceso | date : "dd/MM/yyyy HH:mm" }} hrs.</div>
                  </div>
                  <span class="badge-status badge-success">Sesión activa</span>
               </div>
            </div>

            <div class="mc-card">
               <div class="mc-card-title">Estado del correo</div>
               <div class="security-row">
                  <i class="fas fa-envelope"></i>
                  <div class="sr-info">
                     <div class="sr-title">{{ currentUser.email }}</div>
                     <div class="sr-detail">Correo de acceso principal</div>
                  </div>
                  <span class="badge-status" [ngClass]="emailVerificado ? 'badge-success' : 'badge-neutral'">
                     <i class="fas" [ngClass]="emailVerificado ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
                     {{ emailVerificado ? "Verificado" : "Pendiente" }}
                  </span>
               </div>
               <div class="security-row" *ngIf="!emailVerificado && verificationStep === 'idle'">
                  <i class="fas fa-key"></i>
                  <div class="sr-info">
                     <div class="sr-title">Verificar correo</div>
                     <div class="sr-detail">Te enviaremos un código de 6 dígitos a tu correo para confirmar.</div>
                  </div>
                  <button class="btn-primary-sm" (click)="sendEmailVerificationCode()">
                     <i class="fas fa-paper-plane"></i> Enviar código
                  </button>
               </div>

               <div class="otp-panel" *ngIf="!emailVerificado && verificationStep === 'awaiting-code'">
                  <div class="otp-header">
                     <div class="otp-icon"><i class="fas fa-shield-alt"></i></div>
                     <div class="otp-titles">
                        <div class="otp-title">Confirma tu correo</div>
                        <div class="otp-subtitle">Ingresa el código de 6 dígitos enviado a <strong>{{ currentUser.email }}</strong>.</div>
                     </div>
                  </div>

                  <div class="otp-countdown"
                       *ngIf="!verificationExpired"
                       [class.low]="verificationRemainingIsLow">
                     <i class="far fa-clock"></i>
                     <span>El código expira en <strong>{{ formattedVerificationRemaining }}</strong></span>
                  </div>
                  <div class="otp-countdown otp-countdown-expired" *ngIf="verificationExpired">
                     <i class="fas fa-exclamation-circle"></i>
                     <span>El código expiró. <a class="mc-link" (click)="resendEmailVerificationCode()">Solicitar uno nuevo</a></span>
                  </div>

                  <div class="otp-boxes">
                     <input *ngFor="let d of verificationDigits; let i = index"
                            [id]="'verif-digit-' + i"
                            class="otp-box"
                            [class.filled]="d"
                            [disabled]="verificationExpired"
                            type="text"
                            inputmode="numeric"
                            autocomplete="one-time-code"
                            [value]="d"
                            (input)="onVerificationDigitInput(i, $event)"
                            (paste)="onVerificationDigitPaste(i, $event)"
                            (keydown)="onVerificationDigitKey(i, $event)" />
                  </div>
                  <div class="otp-actions">
                     <a class="mc-link otp-resend" (click)="resendEmailVerificationCode()">
                        <i class="fas fa-redo-alt"></i> Reenviar código
                     </a>
                     <div class="otp-buttons">
                        <button type="button" class="btn-outline-secondary-sm" (click)="cancelEmailVerification()">Cancelar</button>
                        <button type="button" class="btn-primary-sm" [disabled]="verificationCodeValue.length !== 6 || verificationExpired" (click)="confirmEmailVerificationCode()">
                           <i class="fas fa-check"></i> Confirmar
                        </button>
                     </div>
                  </div>
               </div>
            </div>

            <div class="mc-card">
               <div class="mc-card-title">Contraseña</div>
               <div class="security-row">
                  <i class="fas fa-lock"></i>
                  <div class="sr-info">
                     <div class="sr-title">{{ passwordStatusTitle }}</div>
                     <div class="sr-detail">{{ passwordStatusDetail }}</div>
                  </div>
                  <button class="btn-primary-sm" (click)="openPassModal(passModal)">
                     <i class="fas fa-key"></i> {{ passwordActionLabel }}
                  </button>
               </div>
            </div>
         </div>
      </ng-container>

      <!-- ============== METODOS DE ACCESO ============== -->
      <ng-container *ngIf="activeTab === 'metodos'">
         <div class="mc-stack">
            <div class="mc-card mc-methods">
               <div class="method-row" *ngFor="let method of accessMethods">
                  <div class="method-icon" [style.background-color]="method.linked ? '#eef0f8' : '#f7f8fc'">
                     <i [class]="method.iconClass" [style.color]="method.iconColor"></i>
                  </div>
                  <div class="method-info">
                     <div class="method-name">
                        {{ method.name }}
                        <span class="method-principal" *ngIf="method.principal">Principal</span>
                     </div>
                     <div class="method-description">
                        <ng-container *ngIf="method.linked; else notLinked">
                           <a [href]="'mailto:' + method.accountLabel">{{ method.accountLabel }}</a>
                        </ng-container>
                        <ng-template #notLinked>{{ method.description }}</ng-template>
                     </div>
                  </div>
                  <div class="method-actions">
                     <span class="badge-status" [ngClass]="method.linked ? 'badge-success' : 'badge-neutral'">{{ getMethodStatusLabel(method) }}</span>
                     <button *ngIf="!method.linked && method.id !== 'email'" class="btn-outline-primary-sm" (click)="linkAccessMethod(method)">
                        <i class="fas fa-link"></i> Vincular
                     </button>
                     <button *ngIf="method.linked && !method.principal" class="btn-outline-danger-sm" (click)="unlinkAccessMethod(method)">
                        <i class="fas fa-times-circle"></i> Desvincular
                     </button>
                  </div>
               </div>
            </div>

            <div class="mc-alert mc-alert-info">
               <i class="fas fa-exclamation-triangle"></i>
               <div class="mc-alert-text">No se permite desvincular el único método de acceso activo. Antes de desvincular un método, asegúrate de tener al menos otro activo para poder ingresar a tu cuenta.</div>
            </div>
         </div>
      </ng-container>

      <!-- ============== MI BILLETERA ============== -->
      <ng-container *ngIf="puedeVerBilletera && activeTab === 'billetera'">
         <app-mi-billetera></app-mi-billetera>
      </ng-container>

      <!-- ============== EMPRESAS Y SUCURSALES ============== -->
      <ng-container *ngIf="activeTab === 'empresas'">
         <div class="mc-stack">
            <div class="mc-card empresa-selector-card" *ngIf="empresasPermisos.length > 0">
               <div class="empresa-selector-label">
                  <i class="fas fa-building"></i> Empresa
               </div>
               <select class="empresa-selector" [ngModel]="empresaSeleccionadaId" (ngModelChange)="onCambiarEmpresaSeleccionada($event)">
                  <option *ngFor="let item of empresasPermisos" [value]="item.emisor.emisorId">
                     {{ item.emisor.razonSocial }} — RUT {{ item.emisor.rutString || (item.emisor.rut + '-' + item.emisor.dv) }}
                     <ng-container *ngIf="item.emisor.emisorId === emisorId"> (actual)</ng-container>
                  </option>
               </select>
               <span class="empresa-selector-hint">Selecciona una empresa para ver sus sucursales asignadas.</span>
            </div>

            <ng-container *ngIf="empresaSeleccionada as item; else sinEmpresa">
               <div class="mc-card mc-empresa-card">
                  <div class="empresa-header">
                     <div class="empresa-icon"><i class="fas fa-building"></i></div>
                     <div class="empresa-header-info">
                        <div class="empresa-nombre">
                           {{ item.emisor.razonSocial }}
                           <span class="empresa-current-pill" *ngIf="item.emisor.emisorId === emisorId">Empresa actual</span>
                        </div>
                        <div class="empresa-rut">RUT {{ item.emisor.rutString || (item.emisor.rut + '-' + item.emisor.dv) }}</div>
                     </div>
                  </div>

                  <div class="empresa-table-wrap">
                     <table class="empresa-table">
                        <thead>
                           <tr>
                              <th>Sucursal</th>
                              <th>Dirección</th>
                              <th class="text-center">Usuarios</th>
                              <th class="text-center">DTE mes actual</th>
                              <th>Estado</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr *ngFor="let suc of item.sucursales">
                              <td>{{ suc.nombre }}</td>
                              <td><i class="fas fa-map-marker-alt mr-1"></i>{{ suc.direccion }}</td>
                              <td class="text-center">
                                 <span class="stat-pill stat-usuarios">
                                    <i class="fas fa-users"></i>
                                    {{ getStatsForSucursal(suc.sucursalId)?.totalUsuarios ?? 0 }}
                                 </span>
                              </td>
                              <td class="text-center">
                                 <span class="stat-pill stat-dtes">
                                    <i class="fas fa-file-invoice"></i>
                                    {{ getStatsForSucursal(suc.sucursalId)?.totalDtesMesActual ?? 0 }}
                                 </span>
                              </td>
                              <td><span class="badge-status" [ngClass]="suc.activa ? 'badge-success' : 'badge-danger'">{{ suc.activa ? "Activo" : "Inactivo" }}</span></td>
                           </tr>
                           <tr *ngIf="item.sucursales.length === 0">
                              <td colspan="5" class="empty-row">Sin sucursales asignadas</td>
                           </tr>
                        </tbody>
                     </table>
                     <div class="empresa-table-footer">{{ item.sucursales.length }} sucursal(es) asignada(s)</div>
                  </div>
               </div>
            </ng-container>
            <ng-template #sinEmpresa>
               <div class="mc-card" *ngIf="empresasPermisos.length > 0">
                  <div class="empty-row">Selecciona una empresa del listado superior.</div>
               </div>
            </ng-template>

            <div class="mc-alert mc-alert-info">
               <i class="fas fa-shield-alt"></i>
               <div class="mc-alert-text">
                  Aquí puedes consultar las sucursales asignadas a cada empresa donde tienes acceso. Cambiar la empresa en este selector solo modifica la vista; no afecta la empresa con la que estás operando en SimpleFactura. Si necesitas modificar los permisos, contacta al administrador principal del plan o al equipo de soporte.
               </div>
            </div>

            <div *ngIf="empresasPermisos.length === 0" class="mc-card">
               <div class="empty-row">Sin empresas asociadas a tu cuenta.</div>
            </div>
         </div>
      </ng-container>

      <!-- ============== TRANSFERIR USUARIO BASE ============== -->
      <ng-container *ngIf="activeTab === 'cambio-usuario-base'">
         <div class="mc-card">
            <app-cambio-usuario-base-wizard
               [emailUsuarioBase]="currentUser.email"
               (completed)="onCambioUsuarioBaseCompletado()"
               (closeRequested)="onCambioUsuarioBaseCerrado()"
            ></app-cambio-usuario-base-wizard>
         </div>
      </ng-container>
   </div>
   <!-- end::Body -->
</div>

<!-- ============== MODAL: contraseña ============== -->
<ng-template #passModal let-d="dismiss">
   <form [formGroup]="passForm" (ngSubmit)="changePass()" #passFormRef="ngForm">
      <div class="modal-header">
         <h5 class="modal-title">{{ passwordActionLabel }}</h5>
         <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
         </button>
      </div>
      <div class="modal-body">
         <div class="form-group" *ngIf="tienePasswordConfigurada">
            <label>Contraseña actual</label>
            <input type="password" formControlName="currentPass" class="form-control" />
            <div *ngIf="passFormRef.submitted && passForm.get('currentPass').invalid" class="invalid-feedback d-block">Contraseña actual requerida</div>
         </div>
         <div class="form-group">
            <label>Nueva contraseña</label>
            <input type="password" formControlName="pass" class="form-control" autocomplete="off" />
            <div *ngIf="passFormRef.submitted && passForm.get('pass').invalid" class="invalid-feedback d-block">Mínimo 8 caracteres, 1 mayúscula, 1 minúscula y 1 número</div>
         </div>
         <div class="form-group">
            <label>Confirmar nueva contraseña</label>
            <input type="password" formControlName="repeatPass" class="form-control" autocomplete="off" />
            <div *ngIf="passFormRef.submitted && passForm.get('repeatPass').invalid" class="invalid-feedback d-block">Confirma la nueva contraseña</div>
         </div>
      </div>
      <div class="modal-footer">
         <button type="submit" class="btn btn-success">Guardar</button>
         <button type="button" class="btn btn-secondary ml-2" (click)="closePassModal()">Cerrar</button>
      </div>
   </form>
</ng-template>

